const Icon = ({icon, className}) => {
    return <i className={`${icon} ${className ? className : ''}`} />;
   };
    
   export default Icon;